exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".App {\n  width: 100vw;\n  height: 100vh;\n  overflow: hidden;\n  overscroll-behavior-y: contain; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/App.scss
// module id = 185
// module chunks = 0